const toolbox = require('./dist/index');
const { default: Toolbox } = toolbox;
delete toolbox.default;

module.exports = {
    ...toolbox,
    ...Toolbox,
};
